import { Injectable } from '@angular/core';
import { RendererService } from '../services/renderer.service';

import { CameraService } from '../services/camera.service';
declare let THREE: any;

@Injectable()
export class SceneUtilsService {
  constructor(private cameraService: CameraService, private renderer: RendererService) {}

  camera;
  w;
  h;
  position;
  canvas;
  v;
  boundingClientRect;

  screenToWorld(x, y) {
    this.canvas = this.renderer.getCanvas();
    this.w = this.canvas.width;
    this.h = this.canvas.height;
    this.camera = this.cameraService.camera;
    this.position = new THREE.Vector3((x / this.w) * 2 - 1, -(y / this.h) * 2 + 1, 0);
    this.position.unproject(this.camera);
    return this.position;
  }

  worldToScreen(vector3) {
    this.camera = this.cameraService.camera;
    vector3.project(this.camera);
    this.canvas = this.renderer.getCanvas();
    this.boundingClientRect = this.canvas.getBoundingClientRect();
    vector3.x = ((vector3.x + 1) / 2) * this.boundingClientRect.width;
    vector3.y = (-(vector3.y - 1) / 2) * this.boundingClientRect.height;
    return vector3;
  }

  getRay(x, y, rc?) {
    this.canvas = this.renderer.getCanvas();
    x = (x / this.canvas.offsetWidth) * 2 - 1;
    y = -(y / this.canvas.offsetHeight) * 2 + 1;
    this.v = new THREE.Vector3(x, y, 0);
    rc = rc || new THREE.Raycaster();
    rc.setFromCamera(this.v, this.cameraService.camera);
    return rc;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/scene-utils.service.ts